import { render, staticRenderFns } from "./FattuttoConfiguration.vue?vue&type=template&id=2290838f&scoped=true&"
import script from "./FattuttoConfiguration.vue?vue&type=script&lang=js&"
export * from "./FattuttoConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./FattuttoConfiguration.vue?vue&type=style&index=0&id=2290838f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2290838f",
  null
  
)

export default component.exports